import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { Link } from 'react-router-dom'
import { Button, Status } from 'components/misc'
import config from 'config'
import { FormattedMessage } from 'react-intl'
import styles from './assessors-table-row.styl'

export default class AssessorsTableRow extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    expiredWWC: PropTypes.bool,
    onRemindExpiredWWC: PropTypes.func
  }

  static defaultProps = {
    permissions: {},
    params: {},
    activeOrganization: {},
    expiredWWC: false
  }

  getWWCChildProtectionNumber = (assessorWWC, assessorRegistration) => {
    const isApplyCPNNeeded = get(assessorRegistration, 'isApplyCPNNeeded')

    const cpn = get(assessorWWC, 'childProtectionNumber')

    if(cpn && cpn !== '-'){
      return cpn
    }

    if(isApplyCPNNeeded && cpn === '-'){
      return  (<FormattedMessage
        id="label.i_need_apply_cpn"
        defaultMessage="I need to apply for my CPN (Assessor will need to provide WWC before they can start working with participants)"
      />)
    }

    return '---'
  }

  getExpirationDate = (assessorWWC, assessorRegistration) => {
    const isApplyCPNNeeded = get(assessorRegistration, 'isApplyCPNNeeded')

    const cpn = get(assessorWWC, 'childProtectionNumber')

    if(isApplyCPNNeeded && cpn === '-'){
      return (<div>
        {get(assessorWWC, 'assessorWWCExemptionReason') &&  <FormattedMessage id="label.wwc_is_exempted" defaultMessage="Exempted"/>}
        {'NA'}
      </div>)
    } else {
     return (<div>
           {get(assessorWWC, 'assessorWWCExemptionReason') &&  <FormattedMessage id="label.wwc_is_exempted" defaultMessage="Exempted"/>}
           {get(assessorWWC, 'childProtectionExpirationDate') && <FormattedDate value={get(assessorWWC, 'childProtectionExpirationDate')}/>}
            </div>)
    }
  }
  getAssessedActivities = activityCategories => {
    let activityList = []

    activityCategories && activityCategories.map(ac => {
      const actName = get(ac, 'activityCategory.translatedName')

      if(!get(ac, 'isPublicAvailable')){
        activityList.push(<p>{actName} <FormattedMessage
          id="label.did_not_consent_to_assess_others_without_name"
          defaultMessage="(did not consent to assess other participants)"
        /></p>)
      } else {
        activityList.push(<p>{actName}</p>)
      }
    })

    return (<div className={styles.assessedActivities}>{activityList}</div>) || '---'
  }

  remindExpiredWWC = assessorId => {
    this.props.onRemindExpiredWWC(assessorId)
  }

  render() {
    const {
      data: {
        id,
        globalId,
        person,
        firstName,
        lastName,
        email,
        assessorWWC,
        assessorRegistration,
        organization,
        activityCategories,
      },
      data,
      expiredWWC
    } = this.props

    const organizationId = get(organization, 'id')

    const personId = get(person, 'id')

    return (
      <tr key={id}>
         <td>
          <Link
            to={{
              pathname: `${config.publicPath}/organizations/${organizationId}/assessors/${personId}/detail`
            }}
          >
            {globalId || personId}
          </Link>
        </td>
        <td>{firstName || get(person, 'firstName')}</td>
        <td>{lastName || get(person, 'lastName')}</td>
        <td>{email || get(person, 'email')}</td>
        <td>{this.getWWCChildProtectionNumber(assessorWWC, assessorRegistration)}</td>
         <td>{this.getExpirationDate(assessorWWC, assessorRegistration)}</td>
          <td>{this.getAssessedActivities(activityCategories)}</td>
          <td>{get(organization, 'name')}</td>
         <td><Status state={get(person, 'personState')} /></td>
        { expiredWWC && <td>
          <Button type="button" intlKey="button.remind" onClick={() => this.remindExpiredWWC(get(data, 'id'))}>
          Remind
        </Button>
        </td>}

      </tr>
    )
  }
}
